import React, { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../config/hooks";
import { toast } from "sonner";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { createCommentApi, updateCommentApi } from "../../slices/salesSlice";
import { useParams } from "react-router-dom";

const CommentForm = ({ togglePopupHandler, isUpdate = false, initialData }) => {
  const dispatch = useAppDispatch();
  const { userId, who } = useAppSelector((state) => state.login?.session);
  const [isFormValid, setIsFormValid] = useState(true);
  const [commentData, setCommentData] = useState({
    content: initialData?.content || "",
    authorType: who?.toUpperCase() || "",
    authorId: userId,
    // createdBy: userId,
    // updatedBy: userId,
  });

  const clientId = useParams();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const content = commentData.content.trim();

    if (!content || content === '<p><br></p>') {
      setIsFormValid(false);
      toast.error("Content is required!");
      return;
    }

    togglePopupHandler?.();

    try {
      if (isUpdate) {
        dispatch(updateCommentApi({ id:initialData.id,clientId:initialData.clientId,...commentData }));
        toast.success("Comment Updated Successfully");
      } else {
        dispatch(createCommentApi({ clientId: clientId.clientId, ...commentData }))
        toast.success("Comment Created Successfully");
      }
    } catch (error) {
      toast.error("Something went wrong.");
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="w-[50vw] max-h-[80vh] overflow-y-auto bg-white  rounded-lg "
    >
      <div className="mb-16 ">
        <label className="block text-gray-700 mb-2">Comment *</label>
        <ReactQuill
        className="h-28"
          placeholder="Type your comment here..."
          value={commentData.content}
          onChange={(value) =>
            setCommentData((prev) => ({
              ...prev,
              content: value,
            }))
          }
          theme="snow"
        
          
        />
        {!isFormValid && (
          <p className="text-red-500 text-sm mt-2 px-2">Content is required.</p>
        )}
      </div>

      <div className="flex justify-end">
        <button
          type="submit"
          className="bg-primary-500 text-white py-2 px-8 rounded-lg hover:bg-primary-400 focus:outline-none focus:ring focus:ring-blue-300"
        >
          Submit
        </button>
      </div>
    </form>
  );
};


export default CommentForm;
